import React from 'react';

import { RefreshIcon } from '@metarouter-private/mr-mui';

import { useEventDebuggerTableContext } from 'app/event-monitoring/event-debugger/event-debugger-table/EventDebuggerTableContext';

const STATIC_REFRESH_BUTTON_PROPS = {
  size: 'medium',
  variant: 'outlined',
  color: 'secondary',
  startIcon: <RefreshIcon />,
};

export default function useEventDebuggerTableRefreshButtonProps() {
  const { onRefresh } = useEventDebuggerTableContext();

  const refreshButtonProps = {
    ...STATIC_REFRESH_BUTTON_PROPS,
    onClick: onRefresh,
  };

  return refreshButtonProps;
}
